import React from 'react';
import { Container, Row, Col, Card } from 'react-bootstrap';
import { FaBuilding, FaExclamationTriangle, FaWrench, FaCheckSquare } from 'react-icons/fa';
import './Pills.css';

// Custom Health Circle Component
const HealthCircle = ({ percentage }) => {
  const getHealthColor = (percent) => {
    if (percent >= 80) return '#28a745'; // Green
    if (percent >= 60) return '#ffc107'; // Yellow
    if (percent >= 40) return '#fd7e14'; // Orange
    return '#dc3545'; // Red
  };

  const getHealthIconColor = (percent) => {
    if (percent >= 80) return '#28a745'; // Green
    if (percent >= 60) return '#ffc107'; // Yellow
    if (percent >= 40) return '#fd7e14'; // Orange
    return '#dc3545'; // Red
  };

  const radius = 36; // Circle radius
  const circumference = 2 * Math.PI * radius;
  const strokeDasharray = circumference;
  const strokeDashoffset = circumference - (percentage / 100) * circumference;
  const healthColor = getHealthColor(percentage);

  return (
    <div className="health-circle-container">
      <svg width="80" height="80" className="health-circle-svg">
        {/* Background circle */}
        <circle
          cx="40"
          cy="40"
          r={radius}
          fill="none"
          stroke="#e9ecef"
          strokeWidth="4"
        />
        {/* Progress circle */}
        <circle
          cx="40"
          cy="40"
          r={radius}
          fill="none"
          stroke={healthColor}
          strokeWidth="4"
          strokeDasharray={strokeDasharray}
          strokeDashoffset={strokeDashoffset}
          strokeLinecap="round"
          transform="rotate(-90 40 40)"
        />
      </svg>
      <div className="health-circle-text">
        <span>{percentage}%</span>
      </div>
    </div>
  );
};

function Pills({ stats, hvacType }) {
  const { totalUnits, noIssues, foundIssues } = stats;

  let hvacHealth = 0;
  if (totalUnits > 0) {
    const ratio = (noIssues / totalUnits) * 100;
    hvacHealth = Math.round(ratio);
  }

  // Decide which label to show
  const hvacLabel = hvacType === 'heatpump' ? 'Heatpump Health' : hvacType === 'dryer-vent' ? 'Vent Health' : hvacType === 'valve' ? 'Valve Health' : 'Fancoil Health';

  return (
    <div className="pills-container" data-tour="pills-stats">
      <Row className="g-3 mb-4">
        
        {/* Total Units Pill */}
        <Col xs={12} sm={6} md={3}>
          <Card className="shadow-sm border-0 pill-card">
            <Card.Body className="pill-body">
              <div className="pill-icon pill-icon-total">
                <FaBuilding />
              </div>
              <Card.Title className="pill-title pill-title-total">
                Total Units
              </Card.Title>
              <div className="number-circle circle-blue">
                <span>{totalUnits}</span>
              </div>
            </Card.Body>
          </Card>
        </Col>

        {/* No Issues Pill */}
        <Col xs={12} sm={6} md={3}>
          <Card className="shadow-sm border-0 pill-card">
            <Card.Body className="pill-body">
              <div className="pill-icon pill-icon-ok">
                <FaCheckSquare />
              </div>
              <Card.Title className="pill-title pill-title-ok">
                No Issues
              </Card.Title>
              <div className="number-circle circle-green">
                <span>{noIssues}</span>
              </div>
            </Card.Body>
          </Card>
        </Col>

        {/* Found Issues Pill */}
        <Col xs={12} sm={6} md={3}>
          <Card className="shadow-sm border-0 pill-card">
            <Card.Body className="pill-body">
              <div className="pill-icon pill-icon-found">
                <FaExclamationTriangle />
              </div>
              <Card.Title className="pill-title pill-title-found">
                Found Issues
              </Card.Title>
              <div className="number-circle circle-orange">
                <span>{foundIssues}</span>
              </div>
            </Card.Body>
          </Card>
        </Col>

        {/* HVAC Health Pill */}
        <Col xs={12} sm={6} md={3}>
          <Card className="shadow-sm border-0 pill-card">
            <Card.Body className="pill-body">
              <div className="pill-icon pill-icon-health">
                <FaWrench />
              </div>
              <Card.Title className="pill-title pill-title-health">
                {hvacLabel}
              </Card.Title>
              <HealthCircle percentage={hvacHealth} />
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </div>
  );
}

export default Pills;
